import { RecipeId } from './types';
import { buildCount, buildGap, buildList, buildPerGroup, buildRate, buildTrend, RecipeContext, RecipeResult } from './queries';
import { buildQuestions } from './questionRecipes';
import { buildProgress } from './progressRecipes';
import { buildNoCompletion, usesRegisteredBase } from './noCompletionRate';
import { buildReady } from './readyRecipes';
import { buildRanges } from './rangeRecipe';
import { buildCompare, buildShare } from './seriesRecipes';

/** Every question that is built by querying data. A funnel only connects existing KPIs. */
export type QueryRecipeId = Exclude<RecipeId, 'funnel' | 'template' | 'advanced'>;

export const RECIPE_BUILDERS: Record<QueryRecipeId, (c: RecipeContext) => RecipeResult> = {
  count: buildCount, perGroup: buildPerGroup, trend: buildTrend, rate: (c) => (usesRegisteredBase(c.a, c.group.field as string) ? buildNoCompletion(c) : buildRate(c)), gap: buildGap, list: buildList, compare: buildCompare, share: buildShare, questions: buildQuestions, ranges: buildRanges, progress: buildProgress, ready: buildReady,
};
